import { DateRange } from './date-range-chooser.model';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DateRangeChooserService {
  public dateRangeBS = new BehaviorSubject<DateRange>(undefined);

  constructor() {}

  public emitDateRange(dateRange: DateRange): void {
    this.dateRangeBS.next(dateRange);
  }
}
